/**
 * @license
 *
 * Copyright IBM Corp. 2022
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

export enum PRICING_TABLE_HEADER_CELL_TYPES {
  SIMPLE = 'simple',
  COMPLEX = 'complex',
}
